export default __webpack_public_path__ + "static/media/View of delegate seating from Chair podium.3916dfa5.jpg";